import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';


/**
 * ### Accessibility Usage
 * + ***ariaLabelledBy*** - use this to associate an external label with the slider. Use id of the label as this value
 * + ***ariaValueText*** - use this to set an accessible label to the slider
 * + ***id*** - provide an unique id so that this component can be correctly recognized by screen readers. Use interpolation [id]="'unique_id'"
 */
@Component({
    selector: 'agpr-slider-input',
    templateUrl: './slider-input.component.html',
    styleUrls: ['./slider-input.component.scss'],
    providers: [getProvider(SliderInputComponent)],
    standalone: false
})
export class SliderInputComponent extends ControlValueAccessorModel<any> implements AfterViewInit {
    @Input() id: string;
    @Input() max: number = 100;
    @Input() min: number = 0;
    @Input() step: number = 1;
    @Input() leftIcon: string;
    @Input() leftTooltip: string;
    @Input() rightIcon: string;
    @Input() rightTooltip: string;
    @Input() showValue: boolean = true;
    @Input() ariaLabelledBy: string;
    @Input() ariaValueText: string;
    @Input() showMinMaxLabels: boolean = false;

    containerElement: HTMLDivElement;

    readonly buttonTypes = ButtonTypesEnum;

    @Output() changes: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild('container') container: ElementRef;

    ngAfterViewInit(): void {
        this.containerElement = this.container.nativeElement;
    }

    writeValue(value: any): void {
        this.value = value;
    }

    valueChange(value: number): void {
        const activeId = document.activeElement.id;
        this.changes.emit(value);
        this.onModelChange(value);
        requestAnimationFrame(() => {
            document.getElementById(activeId)?.focus();
        });
    }

    valueMin() {
        this.valueChange(this.min);
        this.value = this.min;
    }

    valueMax() {
        this.valueChange(this.max);
        this.value = this.max;
    }
}
